module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8f08a38f9e9878088a218ad02360e369.png";